const faqItems = [
  {
    q: '私密视频播放器是什么？',
    a: '私密视频播放器是一个在线视频平台导航聚合站，为您整合香蕉视频、红桃视频、91视频、蜜桃视频等热门视频平台入口，帮助用户快速找到想看的视频网站，提供一站式的视频大全导航服务。',
  },
  {
    q: '收录的视频平台是否安全可靠？',
    a: '我们对所有收录的在线视频平台进行基础安全审核，优先收录运营稳定、口碑良好的视频网站。但由于各平台独立运营，建议用户在使用时注意个人信息保护，遵守各平台的使用规范。',
  },
  {
    q: '需要注册账号才能使用吗？',
    a: '不需要。私密视频播放器是开放的导航网站，所有用户均可免费浏览和使用平台入口信息，无需注册或登录。各视频平台自身的注册和使用规则请以对应平台为准。',
  },
  {
    q: '视频平台入口多久更新一次？',
    a: '我们的运营团队每周会对收录的视频平台进行可用性检查与信息更新，确保推荐入口保持活跃。如果某个平台出现长期不可用的情况，我们会及时标注或替换。',
  },
  {
    q: '如何推荐新的视频平台收录？',
    a: '欢迎通过「联系我们」板块提供的邮箱渠道提交推荐。请提供平台名称、网址及简要说明，我们的运营团队会在审核后决定是否收录。',
  },
  {
    q: '网站支持手机访问吗？',
    a: '完全支持。私密视频播放器采用响应式设计，在手机浏览器上同样可以流畅浏览和使用所有功能。您只需在手机浏览器中输入网址即可访问全部视频平台导航信息。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-12 md:py-16 px-4 md:px-6 bg-background-100/60">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">常见问题</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            关于私密视频播放器的常见疑问与解答
          </p>
        </div>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, i) => (
            <details
              key={i}
              className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden cursor-pointer"
              open={i === 0}
            >
              <summary className="flex items-center justify-between p-4 md:p-5 list-none">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-background-100 flex items-center justify-center group-open:rotate-45 transition-transform">
                  <i className="ri-add-line text-sm text-foreground-500"></i>
                </span>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}